module.exports = __webpack_public_path__ + "static/media/primary_logo_white_png_transparent_arrow.3d7354a9.png";